
<template>
  <div>
    <div class="indicator" v-if="loading">
      <a-spin :spinning="loading" size="large"> </a-spin>
    </div>
    <a-page-header style="border: 1px solid rgb(235, 237, 240)" :title="title">
      <template v-slot:subTitle>
        <PlusCircleOutlined
          @click="handleAdd"
          v-if="isAddButton"
          :style="{
            fontSize: '22px',
            color: '#11509b',
            marginRight: '8px',
          }"
        ></PlusCircleOutlined>
        <UndoOutlined type="undo" @click="reloadGrid" />
      </template>

      <template v-slot:extra v-if="advanceMenu.length == 0">
        <span v-if="isDateRange">
          <span><strong>{{ $t('js.ngay_dat_hang') }}</strong></span>
          <a-range-picker
            :style="{
              width: '200px',
              display: 'inline-flex',
              margin: '0 8px',
            }"
            :default-value="[
              moment().startOf('month'),
              moment().endOf('month'),
            ]"
            :ranges="{
              [$t('js.hom_qua')]: [
                moment().subtract(1, 'days'),
                moment().subtract(1, 'days'),
              ],
              [$t('js.hom_nay')]: [moment(), moment()],
              [$t('js.thang_nay')]: [moment().startOf('month'), moment().endOf('month')],
              [$t('js.thang_truoc')]: [
                moment().subtract(1, 'months').startOf('month'),
                moment().subtract(1, 'months').endOf('month'),
              ],
            }"
            :locale="locale"
            :format="dateFormat"
            @change="onChangeRangeDate"
          />
        </span>
      </template>
      <template v-slot:extra v-else>
        <span>{{ $t('js.da_chon_count', { count: advanceMenu.length }) }}</span>
        <a-button
          class="mass-del-btn"
          type="danger"
          @click="handleMassDelete"
          v-if="isAddButton"
        >
          {{ $t('js.xoa') }}
        </a-button>
      </template>
    </a-page-header>
    <slot name="tabs"> </slot>
    <o-grid
      ref="grid"
      :entity="entity"
      :columns="columns"
      :title="title"
      :isPopup="false"
      :isAutoLoad="isAutoLoad"
      @editRecord="editRecord($event)"
      @duplicateRecord="duplicateRecord($event)"
      @cancelRecord="cancelRecord($event)"
      @openRecord="openRecord($event)"
      @emitRecord="emitRecord($event)"
      @showAdvance="showAdvance"
      :isAction="isAction"
    >
      <slot name="customRenderList"> </slot>
    </o-grid>
    <a-modal
      :title="title"
      v-model:visible="visible"
      centered
      :okText="$t('js.luu')"
      :ok-button-props="{
        style: {
          background: '#ed1b2f',
          borderColor: '#ed1b2f',
          width: '120px',
        },
      }"
      :cancelText="$t('js.huy_77ab8216')"
      :cancel-button-props="{
        style: { border: 'none' },
      }"
      @ok="handleOk"
      @cancel="handleCancel"
      :width="widthModal"
      :bodyStyle="bodyStyleModal"
      :destroyOnClose="true"
    >
      <component
        :is="detail"
        ref="detail"
        :formData="formData"
        :show="visible"
        :show-confirm="visibleConfirm"
        :spin-loading="loading"
        @confirmSave="confirmSave()"
        @update-form="updateForm($event)"
      ></component>
    </a-modal>
  </div>
</template>
<script>
import { defineComponent } from "vue";

import axios from "axios";
import OneLogGrid from "@/components/Grid/OneLogGrid.vue";
import formUtility from "@/formUtility";
import moment from "moment/moment";
import ColumnConfig from "@/common/ColumnConfig";
import Lang from "@/common/Lang";
import Model from "@/common/Model";

import OrderCustomer from "@/pages/OrderCustomer/Form.vue";
import Location from "@/pages/Location/Form.vue";
import constant from "@/constant";
import {
  UndoOutlined,
  DownloadOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons-vue";

import { datePickerLocale as locale } from "@/common/locale";

export default defineComponent({
  mixins: [formUtility],
  components: {
    "o-grid": OneLogGrid,
    UndoOutlined,
    DownloadOutlined,
    PlusCircleOutlined,
  },
  props: {
    entity: String,
    isAdd: {
      type: Boolean,
      default: true,
    },
    isDateRange: {
      type: Boolean,
      default: false,
    },
    isAction: {
      type: Boolean,
      default: true,
    },
    isAutoLoad: {
      type: Boolean,
      default: true,
    },
    widthModal: String,
    bodyStyleModal: {},
    supportRole: {
      type: Array,
      default: [],
    },
    resetForm: null,
  },
  emits: [
    "handleDate",
    "emitRecord",
    "openRecord",
    "cancelRecord",
    "handleExport",
  ],
  computed: {
    detail() {
      switch (this.entity) {
        case "order-customer":
          return OrderCustomer;
        case "location":
          return Location;
        case "contact":
          return Contact;
      }
    },
  },
  data() {
    let entity = this.convertPascalCase(this.entity);
    let columns = ColumnConfig[entity] || [];
    let title = Lang[entity].name || "";

    let form = this.generateFormData(Model[entity]) || {};
    return {
      dateFormat: "DD/MM/YYYY",
      moment,
      locale,
      visible: false,
      visibleConfirm: false,
      confirmLoading: false,
      formData: form,
      id: null,
      isAddButton: this.isAdd,
      columns,
      title,
      dateChange: {},
      config: Model[entity],
      advanceMenu: [],
      loading: false,
      isShowModal: false,
      spinning: false,
    };
  },
  methods: {
    reloadGrid() {
      this.reload();
    },
    reload(filter) {
      if (this.$refs.grid) {
        this.$refs.grid.reload(filter);
      }
    },
    showModal() {
      this.visible = true;
    },
    handleAdd() {
      this.id = null;
      if (this.$refs.detail) {
        this.$refs.detail.$refs.ruleForm.resetFields();
      }
      this.formData = this.generateFormData(this.config);
      this.formData["mode"] = "add";
      if (this.$refs.detail) {
        this.$refs.detail.form = this.formData;
      }
      if (this.$refs.detail && this.$refs.detail.relationForm) {
        for (let prop in this.$refs.detail.relationForm) {
          this.$refs.detail.relationForm[prop] = [];
        }
      }
      this.visible = true;
    },
    handleOk(e) {
      e.preventDefault();
      this.visibleConfirm = false;
      this.$refs.detail.$refs.ruleForm.validate().then(() => {
        this.loading = true;
        this.confirmLoading = true;
        let form = this.convertFormData();

        try {
          if (this.$refs.detail.showModalConfirm) {
            this.isShowModal = true;
            this.confirmLoading = false;
            this.visibleConfirm = true;
            this.formData = form;
          } else {
            this.saveFormData(form);
          }
        } catch (err) {
          console.error(err);
          this.$message.error(err);
        }
      });
    },
    convertFormData(callback) {
      let form = JSON.parse(JSON.stringify(this.$refs.detail.form));

      if (this.id) {
        form.id = this.id;
      }
      for (let prop in form) {
        for (let propConfig in this.config) {
          if (this.config[propConfig].relation == prop) {
            form[prop + "_id"] = form[prop]["key"];
            delete form[prop];
          }
          if (this.config[propConfig].relationDefault == prop) {
            form[prop + "_id"] = form[prop]["key"];
            delete form[prop];
          }
        }
        if (this.config[prop] && this.config[prop].dataType) {
          if (this.config[prop].dataType == "time") {
            form[prop] = moment(form[prop]).format("H:mm:ss");
          }
        }
      }
      if (this.$refs.detail.relationForm) {
        for (let prop in this.$refs.detail.relationForm) {
          form[prop] = JSON.parse(
            JSON.stringify(this.$refs.detail.relationForm[prop])
          );
        }
      }
      if (callback) {
        form = callback(form);
      }
      return form;
    },
    updateForm($event) {
      if (!this.$refs.detail.form) return;
      try {
        let form = this.convertFormData($event);
        this.saveFormData(form);
      } catch (err) {
        this.$message.error(err);
      }
    },
    saveFormData(form) {
      axios
        .post(`c-${this.entity}/save`, form)
        .then((response) => {
          this.confirmLoading = false;
          this.isShowModal = false;
          if (response.data.errorCode != 0) {
            if (Array.isArray(response.data.errorMessage)) {
              this.$message.error(
                response.data.errorMessage.map((p) => p.errorMessage).join("\n")
              );
            } else {
              this.$message.error(response.data.errorMessage);
            }
            this.loading = false;
            return false;
          }
          this.visible = false;
          this.loading = false;

          this.$message.success(this.$t('js.luu_name_thanh_cong', { name: this.title }));

          if (this.$refs.grid) {
            this.$refs.grid.reload();
          }
        })
        .catch((error) => {
          console.error(error);
          this.confirmLoading = false;
          this.$message.error(error.message);
        });
    },
    onChangeRangeDate(value, dateString) {
      let dateChange = {
        fromDate: dateString[0],
        toDate: dateString[1],
      };
      this.$emit("handleDate", dateChange);
    },
    handleExport() {
      this.$emit("handleExport");
    },
    handleCancel(e) {
      this.visible = false;
      this.isShowModal = false;
      this.visibleConfirm = false;
      this.loading = false;
    },
    openRecord(record) {
      this.loading = true;
      axios
        .get(`c-${this.entity}/detail?id=${record.id}`)
        .then((response) => {
          if (response.data.errorCode != 0) {
            if (Array.isArray(response.data.errorMessage)) {
              this.$message.error(
                response.data.errorMessage.map((p) => p.errorMessage).join("\n")
              );
            } else {
              this.$message.error(response.data.errorMessage);
            }
            return;
          }
          this.loading = false;
          this.$emit("openRecord", response);
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    emitRecord(record) {
      this.$emit("emitRecord", record);
    },
    showAdvance(record) {
      this.advanceMenu = record;
    },
    editRecord(record, callback) {
      this.id = record.id;
      this.loading = true;
      this.visibleConfirm = false;
      if (this.$refs.detail) {
        this.$refs.detail.$refs.ruleForm.resetFields();
      }
      axios
        .get(`c-${this.entity}/detail?id=${record.id}`)
        .then((response) => {
          if (response.data.errorCode != 0) {
            if (Array.isArray(response.data.errorMessage)) {
              this.$message.error(
                response.data.errorMessage.map((p) => p.errorMessage).join("\n")
              );
            } else {
              this.$message.warning(response.data.errorMessage);
            }
            return;
          }
          let data = response.data.data;
          this.formData = this.generateFormData(this.config);
          for (let prop in this.config) {
            this.formData[prop] = data[prop];

            let config = this.config[prop];
            if (config.relation) {
              this.formData[config.relation] = {
                key: data[config.relation + "_id"] || "",
                label: data["name_of_" + config.relation + "_id"] || "",
              };
            }
            if (config.relationDefault) {
              this.formData[config.relationDefault] = {
                key: data[config.relationDefault + "_id"] || "",
                value: data["name_of_" + config.relationDefault + "_id"] || "",
              };
            }

            if (config.dataType) {
              if (config.dataType == "date") {
                this.formData[prop] = moment.utc(data[prop], "YYYY-MM-DD");
              }
              if (config.dataType == "time") {
                this.formData[prop] = moment.utc(data[prop], "H:mm:ss");
              }

              if (config.dataType == "array") {
                if (config.dataRelation) {
                  for (let i = 0; i < config.dataRelation.length; i++) {
                    for (let j = 0; j < data[prop].length; j++) {
                      let item = data[prop][j];
                      item[config.dataRelation[i]] = {
                        key: item[config.dataRelation[i] + "_id"],
                        label:
                          item["name_of_" + config.dataRelation[i] + "_id"],
                      };
                    }
                  }
                }
                if (config.fields) {
                  Object.keys(config.fields).map((i) => {
                    for (let j = 0; j < data[prop].length; j++) {
                      let item = data[prop][j];
                      if (config.fields[i].dataType == "bool") {
                        if (item[i] == 1) {
                          item[i] = true;
                        } else {
                          item[i] = false;
                        }
                      }
                    }
                  });
                }
              }
            }
          }
          this.formData["mode"] = "edit";
          if (this.$refs.detail) {
            this.$refs.detail.form = this.formData;
          }
          if (this.$refs.detail && this.$refs.detail.relationForm) {
            for (let prop in this.$refs.detail.relationForm) {
              this.$refs.detail.relationForm[prop] = JSON.parse(
                JSON.stringify(this.formData[prop])
              );
            }
          }
          if (callback) {
            callback();
          }
          console.log(this);
          this.visible = true;
          this.loading = false;

          // this.$emit("editRecord", this.formData);
        })
        .catch((error) => {
          console.error(error);

          this.loading = false;
          this.$message.error(error.message);
        });
    },
    duplicateRecord(record) {
      let self = this;
      this.editRecord(record, function () {
        self.formData["id"] = null;
        self.formData["code"] = "";
        if (self.resetForm) {
          self.resetForm(self);
        }
        self.id = null;
        self.formData["mode"] = "duplicate";
      });
    },

    handleMassDelete() {
      let recordId = this.advanceMenu;
      let data = this.$refs.grid.data;
      let grid = this.$refs.grid;
      let recordCode = [];
      let code = "code";
      let entity = this.entity;
      let component = this;
      let count = 0;

      if (Object.keys(constant.entityFieldCode).includes(entity)) {
        code = constant.entityFieldCode[entity];
      }

      data.forEach((record) => {
        if (recordId.includes(record.id)) {
          recordCode.length < 3 ? recordCode.push(record[code]) : count++;
        }
      });

      if (recordCode.length >= 2 && count > 0) {
        recordCode.push(component.$t('js.va_count_name_con_lai', {
          count,
          name: component.title
        }));
      }

      this.$confirm({
        title: component.$t('js.ban_chac_chan_muon_xoa_name_records', {
          name: component.title,
          records: recordCode.join(', ')
        }),
        content: "",
        okText: window.__t('js.xac_nhan'),
        cancelText: window.__t('js.huy'),
        onOk() {
          axios
            .delete(`c-${entity}?id=${recordId.join(",")}`)
            .then((response) => {
              if (response.data.errorCode == 0) {
                component.$message.success(component.$t('js.xoa_name_thanh_cong', {
                  name: component.title
                }));
                component.reload();
                component.advanceMenu = [];
                grid.reload();
              } else {
                component.$message.error(response.data.errorMessage);
              }
            })
            .catch((error) => {
              console.error(error);
              component.$message.error(error.message);
            });
        },
        onCancel() {},
      });
    },
    confirmSave() {
      this.visibleConfirm = false;
      this.loading = false;
    },
    cancelRecord(record) {
      this.$emit("cancelRecord", record);
    },
  },
});
</script>
<style lang="scss" scoped>
.indicator {
  position: absolute;
  z-index: 999;
  background: #c9b8b824;
  height: 100vh;
  width: 100vw;
  text-align: center;
}
.indicator :deep() .ant-spin {
  top: 35%;
  position: absolute;
}
.ant-page-header {
  padding: 16px 8px 12px;
}
.anticon.anticon-undo {
  vertical-align: middle;
}
</style>
<style lang="scss">
.ant-page-header-heading-sub-title {
  display: flex;
  align-items: center;
}
</style>
